// Cada visor puede tener su propia instancia y cancelar únicamente su conexión.
export class StreamLogsService {
  constructor() {
    this.session = null;
    this.isConnected = false;
    this.currentUrl = null;
  }

  async connect(streamUrl, onLog, onError, onOpen, onClose) {
    this.disconnect();
    if (!streamUrl) {
      onError?.(new Error("No se recibió la URL del stream."));
      return;
    }
    const session = { controller: new AbortController(), reader: null };
    this.session = session;
    this.currentUrl = streamUrl;
    const current = () => this.session === session && !session.controller.signal.aborted;
    try {
      const response = await fetch(streamUrl, {
        method: "GET",
        headers: { Accept: "text/plain" },
        signal: session.controller.signal,
      });
      if (!current()) {
        await response.body?.cancel();
        return;
      }
      if (!response.ok) throw new Error(`No se pudo abrir el stream (HTTP ${response.status}).`);
      if (!response.body) throw new Error("El servidor no entregó un stream de logs.");
      session.reader = response.body.getReader();
      const reader = session.reader;
      const decoder = new TextDecoder();
      let buffer = "";
      this.isConnected = true;
      onOpen?.();
      const emit = (line) => {
        if (current() && line.trim()) onLog(line.replace(/\r$/, ""));
      };
      while (current()) {
        const { done, value } = await reader.read();
        if (!current()) return;
        if (done) {
          buffer += decoder.decode();
          emit(buffer);
          break;
        }
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop() || "";
        lines.forEach(emit);
      }
    } catch (error) {
      if (current() && error.name !== "AbortError") onError?.(error);
    } finally {
      try {
        session.reader?.releaseLock();
      } catch {
        /* El reader puede seguir cancelándose. */
      }
      if (this.session === session) {
        this.session = null;
        this.currentUrl = null;
        this.isConnected = false;
        onClose?.();
      }
    }
  }

  disconnect() {
    const session = this.session;
    this.session = null;
    this.isConnected = false;
    this.currentUrl = null;
    if (session) {
      session.controller.abort();
      session.reader?.cancel().catch(() => {});
    }
  }

  get connectionStatus() {
    return this.isConnected;
  }

  get currentStreamUrl() {
    return this.currentUrl;
  }
}
export default new StreamLogsService();
